(() => {
  const init = (root) => {
    if (!root || root.dataset.meV840Ready === 'true') return;
    root.dataset.meV840Ready = 'true';

    const details = [...root.querySelectorAll('.me-pp-details details')];
    details.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        details.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    const primaryCta = root.querySelector('.me-pp-summary__personalize');
    const mobileCta = root.querySelector('[data-me-v840-mobile-cta]');
    if (!primaryCta || !mobileCta || !window.matchMedia('(max-width: 749px)').matches) return;

    mobileCta.hidden = false;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting);
      mobileCta.classList.toggle('is-ready', !visible);
    }, { threshold: 0.2 });
    observer.observe(primaryCta);
  };

  const boot = () => document.querySelectorAll('.me-pp--v840').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
